import { Action } from '@ngrx/store';

import { MhSelection } from '../../modules/common/entities/user/selection.entity';

export enum SelectionActionTypes {
    Set = '[Selection] Set',
    Unset = '[Selection] Unset',
    Fail = '[Selection] Fail'
}

export class SetSelection implements Action {
    type: SelectionActionTypes.Set = SelectionActionTypes.Set;
    constructor(public payload: MhSelection) {}
}

export class UnsetSelection implements Action {
    type: SelectionActionTypes.Unset = SelectionActionTypes.Unset;
}

export class SelectionFail implements Action {
    type: SelectionActionTypes.Fail = SelectionActionTypes.Fail;
}

export type SelectionActions = SetSelection | UnsetSelection | SelectionFail;
